import { render, staticRenderFns } from "./SupplierManufacturingTransport.vue?vue&type=template&id=0c0ba730&scoped=true&"
import script from "./SupplierManufacturingTransport.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0ba730",
  null
  
)

export default component.exports